export type FeedbackKind = "bug" | "feature" | "other";

/**
 * Free text on purpose, so it has a port of its own: the analytics client
 * takes scalars only, which is what keeps draft content out of events.
 * `screen` is the path of the page, with no query string or fragment. It may
 * carry a draft's or a client's id, never a title. The adapter's helpdesk may
 * record the full page URL on its own.
 */
export interface Feedback {
  kind: FeedbackKind;
  text: string;
  browser: string;
  os: string;
  screen: string;
}

/** Who to write back to: all the session knows beyond the user id. */
export interface Reporter {
  email: string | undefined;
}

/** Never a throw, so the form can stay open with the text kept. */
export type SubmitResult =
  | { ok: true; ticketId: string }
  | { ok: false; reason: "failed" }
  // Nowhere to send: no project key, Support off, or PostHog blocked.
  | { ok: false; reason: "unavailable" }
  // Given up on while still going, so it may yet make a ticket.
  | { ok: false; reason: "timed_out" };

/**
 * Implemented by the PostHog adapter, and by the client below when the build
 * has nowhere to send, so the header never asks whether a project key exists.
 */
export interface SupportClient {
  /** A yes is kept for the visit; a no, or no answer in time, is asked again. */
  isAvailable: () => Promise<boolean>;
  submit: (feedback: Feedback, reporter: Reporter) => Promise<SubmitResult>;
}

const NEVER_AVAILABLE = Promise.resolve(false);

export const unavailableSupport: SupportClient = {
  isAvailable: () => NEVER_AVAILABLE,
  submit: () => Promise.resolve({ ok: false, reason: "unavailable" }),
};
